<dialog
  #modal
  [style.width.px]="settings()?.width"
  [style.height.px]="settings()?.height"
>
  <!-- Modal Header -->
  <div uimodalheader [class]="headerCssClass()">
    @if (label()) {
      <span uimodaltitle>{{ label() }}</span>
    }
    <ng-content select="[uimodalheader]"></ng-content>

    <!-- Modal Tools -->
    <div uitoolStrip>
      <ng-content select="[uimodaltool]"></ng-content>
    </div>
  </div>

  <!-- Modal Content -->
  @if (contentDir.uicontentcomponent()) {
    <ng-template
      *ngComponentOutlet="
        contentDir.uicontentcomponent();
        inputs: contentDir.uicontentinput()
      "
    ></ng-template>
  } @else if (settings().useRouterOutlet) {
    <router-outlet class="hidden"></router-outlet>
  } @else if (settings().useNgContent) {
    <ng-content select="div[uimodalcontent]"></ng-content>
  } @else {
    <div
      uimodalcontent
      [class]="contentCssClass()"
      [uiloading]="loadingDir.uiloading()"
    >
      @if (text()) {
        @if (settings().textFormatter === 'json') {
          <pre>{{ JSON.parse(text()!) | json }}</pre>
        } @else if (settings().textFormatter === 'html') {
          <div class="contents" [innerHTML]="text()"></div>
        } @else {
          <p>{{ text() }}</p>
        }
      }
      <ng-content></ng-content>
      <ng-container
        *ngTemplateOutlet="
          contentDir.uicontenttemplate();
          context: {
            $implicit: contentDir.uicontentcontext(),
            more: contentDir.uicontentcontextmore(),
          }
        "
      ></ng-container>
    </div>
  }

  <!-- Modal Footer -->
  @if (!contentDir.uicontentcomponent()) {
    <div uimodalfooter [class]="footerCssClass()">
      <ng-content select="[uimodalfooter]"></ng-content>
      @for (action of settings().actions; track $index) {
        <btn
          [class]="action.class"
          [settings]="{
            label: action.label,
            disabled: action.disabled,
            icon: action.icon,
          }"
          (click)="action.action()"
        ></btn>
      }
    </div>
  }
</dialog>
